import React from "react";

/**
 * Arrow Forward icon component
 * @param {Object} props - Component props
 * @param {string} [props.color='000'] - The color of the icon
 * @param {number} [props.size=16] - The size of the icon
 * @param {string} [props.viewBox='0 0 16 16'] - The SVG viewBox attribute
 * @returns {React.ReactElement} Arrow Forward icon
 */
export const ArrowForward = ({
  color = "000",
  size = 16,
  viewBox = "0 0 16 16",
}) => (
  <svg
    width={size}
    height={size}
    viewBox={viewBox}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.3905 6.66668L9.52859 3.80475L10.4714 2.86194L14.9428 7.33334L10.4714 11.8047L9.52859 10.8619L12.3905 8.00001H8.66667C4.16904 8.00001 2.66667 9.56248 2.66667 14H1.33333C1.33333 8.83754 3.4207 6.66668 8.66667 6.66668H12.3905Z"
      fill={color}
    />
  </svg>
);
